module.exports = __webpack_public_path__ + "img/bah.d0289dc0.png";